var _a;
import debug from 'debug';
import isServer from './utils/is-server';
const rootNamespace = 'sitecore-jss';
// On server/node side, allow switching from the built-in
// `%o` (pretty-print single line) and `%O` (pretty-print multiple line)
// with a `DEBUG_MULTILINE` environment variable.
if (isServer() &&
    ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.DEBUG_MULTILINE) === 'true' &&
    debug.formatters.o &&
    debug.formatters.O) {
    debug.formatters.o = debug.formatters.O;
}
/**
 * Enable debug logging dynamically
 * @param {string} namespaces space-separated list of namespaces to enable
 */
export const enableDebug = (namespaces) => debug.enable(namespaces);
/**
 * Default Sitecore JSS 'debug' module debuggers. Uses namespace prefix 'sitecore-jss:'.
 * See {@link https://www.npmjs.com/package/debug} for details.
 */
export default {
    form: debug(`${rootNamespace}:form`),
    common: debug(`${rootNamespace}:common`),
    http: debug(`${rootNamespace}:http`),
    layout: debug(`${rootNamespace}:layout`),
    dictionary: debug(`${rootNamespace}:dictionary`),
    editing: debug(`${rootNamespace}:editing`),
    sitemap: debug(`${rootNamespace}:sitemap`),
    multisite: debug(`${rootNamespace}:multisite`),
    robots: debug(`${rootNamespace}:robots`),
    redirects: debug(`${rootNamespace}:redirects`),
    personalize: debug(`${rootNamespace}:personalize`),
    errorpages: debug(`${rootNamespace}:errorpages`),
    proxy: debug(`${rootNamespace}:proxy`),
};
